import { schema } from "normalizr";
export const templateConditional = new schema.Entity("dtcTemplateConditional");
